"use client";

import React, { useState } from "react";

interface InputFieldProps {
    label?: string;
    type?: string;
    placeholder?: string;
    iconLeft?: React.ReactNode;
    iconRight?: React.ReactNode;
    accept?: string;
    value?: string; // Добавлено
    onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    errorMessage?: string; 
    required?: boolean; 
}

const InputField: React.FC<InputFieldProps> = ({
    label,
    type = "text",
    placeholder = "",
    iconLeft = null,
    iconRight = null,
    accept = "",
    value: externalValue, // Переименовываем переданное значение
    onChange,
    errorMessage,
    required = false 
}) => {
    const [internalValue, setInternalValue] = useState("");

    const isControlled = externalValue !== undefined;
    const value = isControlled ? externalValue : internalValue;

    const [isFocused, setIsFocused] = useState(false);

    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (type === "file") {
            const fileName = (e.target as HTMLInputElement).files?.[0]?.name || "";
            if (!isControlled) setInternalValue(fileName);
        } else {
            if (!isControlled) setInternalValue(e.target.value);
        }

        if (onChange) {
            onChange(e);
        }
    };

    return (
        <div className="relative w-full">
            {label && (
                <label
                    className={`absolute -top-2 left-[14px] text-[12px] leading-[133%] tracking-[0.03em] uppercase bg-white px-[4px] py-[2px] transition-all max-[576px]:text-[10px] ${
                        isFocused || value ? "text-[#3b49c0]" : "text-violet-300"
                    }`}
                >
                    {label}
                </label>
            )}
            <div
                className={`flex items-center border-[1.5px] rounded-[12px] pl-[14px] pr-[14px] py-[16px] max-[576px]:py-[12px] transition-all ${
                    isFocused ? "border-[#3b49c0]" : "border-violet-50"
                }`}
            >
                {iconLeft && <span className="text-gray-400 mr-3">{iconLeft}</span>}
                {type === "textarea" ? (
                    <textarea
                        value={value}
                        placeholder={placeholder}
                        className="w-full outline-none text-violet-200 text-[18px] resize-none h-[128px] max-[576px]:text-[14px] max-[576px]:h-[96px]"
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                ) : type === "file" ? (
                    <div className="relative w-full">
                        <input
                            type="file"
                            accept={accept}
                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                        <button
                            type="button"
                            className="w-full text-left text-sm text-gray-600 rounded-lg"
                        >
                            {value || "Upload your CV"}
                        </button>
                    </div>
                ) : (
                    <input
                        type={type}
                        value={value}
                        placeholder={placeholder}
                        className="w-full outline-none text-violet-200 text-[18px] max-[576px]:text-[14px]"
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                )}
                {iconRight && type !== "textarea" && (
                    <span className="text-gray-400 ml-3">{iconRight}</span>
                )}
            </div>

            {errorMessage && <div className="text-red-500 text-sm mt-2">{errorMessage}</div>}

            {required && <span className="text-red-500 ml-1 text-lg">*</span>}
        </div>
    );
};

export default InputField;
